import React, { FC } from 'react'
import { Container, TextSection } from './Notification.style'
import Icon from '@components/style/Icon.style'
import theme from 'parkdepot-shared/theme'

type Props = {
    text: string
}

export const Notification: FC<Props> = ({ text }) => {
    return (
        <Container>
            <Icon className="wemolo-info-circle" color={theme.colors.primary} />
            <TextSection>{text}</TextSection>
        </Container>
    )
}
